import React, { Component } from 'react';
import '../../scss/AddressInput.scss';

export default class AddressInput extends Component {
  constructor(props) {
    super(props);
    this.state = {value: this.props.address || ''};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.address && nextProps.address !== this.state.value) {
      this.setState({ value: nextProps.address });
    }
  }

  onChange(e) {
    this.setState({ value: e.target.value });
  }

  onSubmit(e) {
    e.preventDefault();
    this.input.nextElementSibling.blur();
    this.props.onSubmit(this.input.value);
  }

  render() {
    return (
      <form className="AddressInput" onSubmit={this.onSubmit.bind(this)}>
        <input
         placeholder="123 Broadway NY, NY"
         value={this.state.value}
         onChange={this.onChange.bind(this)}
         className="AddressInput__input"
         name="address-input"
         type="text"
         ref={input => this.input = input} />
        <input type="submit" value="Go" />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/lib/AddressInput.js